import { useState } from "react";
import { statusLabel, fmtDate, STATUS_COLOR } from "./constants";
import { DetailModal, TrackingPanel, InteractionForm, InteractionsList, HistoryList } from "./DetailShared";

export function EmployerDetail({ id, data, onClose, onChanged, onOpenCandidate, onOpenOffer }) {
  const [tab, setTab] = useState("infos");
  const info = data.info || {};
  const company = info.company || {};
  return (
    <DetailModal testid="employer-detail" title={company.name || info.name} subtitle={`${info.email} · ${info.nexa_id || ""}`}
      onClose={onClose} activeTab={tab} setActiveTab={setTab}
      tabs={[["infos", "Informations"], ["offres", `Offres (${data.offers.length})`], ["candidats", `Candidats (${data.candidates.length})`],
             ["interactions", `Historique (${data.interactions.length})`], ["suivi", "Suivi & statuts"]]}>
      {tab === "infos" && (
        <div data-testid="employer-tab-infos" className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
          {[
            ["Raison sociale", company.name || info.name], ["Contact", info.name], ["Courriel", info.email],
            ["Téléphone", info.phone || "—"], ["Ville", company.city || "—"], ["Province", company.province || "—"],
            ["Secteur", company.sector || "—"], ["Site Web", company.website || "—"], ["Taille", company.size || "—"],
            ["Inscription", fmtDate(info.created_at)], ["Statut commercial", statusLabel(data.tracking?.commercial_status || "nouveau_prospect")],
            ["Responsable", data.tracking?.assignee || "—"],
          ].map(([k, v]) => (
            <div key={k} className="bg-slate-50 rounded-lg p-3"><p className="text-xs text-slate-500">{k}</p><p className="font-medium text-brand-navy break-words">{v}</p></div>
          ))}
        </div>
      )}
      {tab === "offres" && (
        <div data-testid="employer-tab-offres" className="space-y-2 max-h-80 overflow-y-auto">
          {data.offers.length === 0 && <p className="text-sm text-slate-400 text-center py-6">Aucune offre pour cet employeur.</p>}
          {data.offers.map((o) => (
            <button key={o.offer_id} data-testid={`employer-offer-${o.offer_id}`} onClick={() => onOpenOffer(o.offer_id)}
              className="w-full text-left border border-slate-100 rounded-lg px-4 py-3 hover:border-brand-turquoise transition-colors flex items-center justify-between gap-3">
              <div>
                <p className="font-medium text-brand-navy text-sm">{o.title}</p>
                <p className="text-xs text-slate-500">{[o.city, o.country].filter(Boolean).join(", ")} · {o.applications_distinct} candidat(s)</p>
              </div>
              <span className={`text-xs font-medium rounded-full px-2.5 py-1 ${["active", "publiee"].includes(o.status) ? "bg-green-50 text-green-700" : "bg-slate-100 text-slate-500"}`}>{o.status}</span>
            </button>
          ))}
        </div>
      )}
      {tab === "candidats" && (
        <div data-testid="employer-tab-candidats" className="space-y-2 max-h-80 overflow-y-auto">
          {data.candidates.length === 0 && <p className="text-sm text-slate-400 text-center py-6">Aucun candidat associé à ses offres.</p>}
          {data.candidates.map((c) => (
            <button key={c.candidate_id} data-testid={`employer-candidate-${c.candidate_id}`} onClick={() => onOpenCandidate(c.candidate_id)}
              className="w-full text-left border border-slate-100 rounded-lg px-4 py-3 hover:border-brand-turquoise transition-colors flex items-center justify-between gap-3">
              <div>
                <p className="font-medium text-brand-navy text-sm">{c.name}</p>
                <p className="text-xs text-slate-500">{c.profession || "—"} · {c.country || "—"}</p>
              </div>
              <span className={`text-xs font-medium rounded-full px-2.5 py-1 ${STATUS_COLOR(c.application_status)}`}>
                {statusLabel(c.application_status, "candidate")}
              </span>
            </button>
          ))}
        </div>
      )}
      {tab === "interactions" && (
        <div data-testid="employer-tab-interactions">
          <InteractionForm testid="employer" entityType="employer" entityId={id} onAdded={onChanged} />
          <InteractionsList testid="employer" interactions={data.interactions} />
        </div>
      )}
      {tab === "suivi" && (
        <div data-testid="employer-tab-suivi" className="space-y-4">
          <TrackingPanel testid="employer" entityType="employer" entityId={id}
            tracking={data.tracking} statuses={data.statuses} onChanged={onChanged} />
          <HistoryList testid="employer" history={data.status_history} />
        </div>
      )}
    </DetailModal>
  );
}
